var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('board-cell-card',{attrs:{"title":"设备FTT变化趋势"}},[_c('div',{attrs:{"id":"score-history-chart"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }